import { TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";

interface MatchBadgeProps {
  percentage: number;
  size?: "sm" | "md" | "lg";
  showLabel?: boolean;
  className?: string;
}

export function MatchBadge({ percentage, size = "md", showLabel = true, className }: MatchBadgeProps) {
  const level = percentage >= 80 ? "high" : percentage >= 50 ? "medium" : "low";

  const colors = {
    high: "bg-green-100 text-green-800 border-green-200",
    medium: "bg-yellow-100 text-yellow-800 border-yellow-200",
    low: "bg-muted text-muted-foreground border-border",
  };

  const sizes = {
    sm: "text-[10px] px-1.5 py-0.5 gap-0.5",
    md: "text-xs px-2 py-1 gap-1",
    lg: "text-sm px-3 py-1.5 gap-1.5",
  };

  return (
    <span className={cn(
      "inline-flex items-center rounded-full font-semibold border",
      colors[level],
      sizes[size],
      className
    )}>
      <TrendingUp className={cn(size === "sm" ? "w-3 h-3" : size === "md" ? "w-3.5 h-3.5" : "w-4 h-4")} />
      {percentage}%{showLabel && " match"}
    </span>
  );
}
